import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { ListingTermsConditionModal } from 'Layout/Modals/containers'
import AppButton from 'Components/AppButton'


import { _ListingTermsContainer, _ModalContainer, _ViewTermsAgreeContainer, _ViewTermsAgreeText } from './styles'

const ListingTermsUseContainer = ({ winWidth, listingSource, openListingTermsConditionModal }) => {
  const dispatch = useDispatch()
  const openTermsConditionModal =
    () => dispatch(openListingTermsConditionModal({ modalData: { listingSource } }))

  useEffect(() => {
    if(winWidth <= 767) {
      openTermsConditionModal()
    }
  }, [dispatch])
  return (
    <_ListingTermsContainer data-test-id="listingTermsUseContainer">
      <_ModalContainer>
        <ListingTermsConditionModal
          heroView
          listingSource={listingSource}
        />
      </_ModalContainer>
      <_ViewTermsAgreeContainer>
        <_ViewTermsAgreeText>
          View {listingSource?.name}{listingSource?.name === 'PILLAR9' ? '\u2122' : ''} terms and conditions
        </_ViewTermsAgreeText>

        <AppButton
          data-test-id="viewTermsConditionBtn"
          primary
          medium
          fluid
          onClick={() => {
            dispatch(openListingTermsConditionModal({ modalData: { listingSource } }))
          }}
        >
          View
        </AppButton>
      </_ViewTermsAgreeContainer>

    </_ListingTermsContainer>
  )
}

ListingTermsUseContainer.propTypes = {
  listingSource: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.number,
  }),
  winWidth: PropTypes.number,
  openListingTermsConditionModal: PropTypes.func,
}

export default ListingTermsUseContainer
